@import '~style-sheet-helpers/core.less';

.order-summary-gift-details {
  padding: 5px;
}
